import StudentInformation from "./Student.Information";
import CompanyInformation from "./Company.Information";
import SchoolInformation from "./School.Information";
import DriverInformation from "./Driver.Information";
import ParentInformation from "./Parent.Information";

import "./index.scss";

const ShowInformation = () => {
  return (
    <section>
      <StudentInformation />
      <CompanyInformation />
      <SchoolInformation />
      <DriverInformation />
      <ParentInformation />
    </section>
  );
};

export default ShowInformation;
